import Api from '@CardGame/api'
import MockApi from '@CardGame/api/mock'

const API_URL = process.env.VUE_APP_API_URL

export default function useApi () {
  if (API_URL === 'mock') return new MockApi()
  return new Api(API_URL)
}
